module.exports = __webpack_public_path__ + "img/planta_01.7d8dee93.png";